import React from "react";
import { useQuery } from "@apollo/client";
import type { Theme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";
import { PermitSubNavigation } from "@curbsuite/components/permits";
import type { PermitSubNavigationItem } from "@curbsuite/components/permits";
import Container from "@mui/material/Container";
import { GET_PERMIT_STATS, GetPermitStatsData } from "common/graphql";
import useAccountContextBannerVisible from "@app.automotus.io/components/AccountContextBanner/useAccountContextBannerVisible";

export const PermitsLayout: React.FC = () => {
  const { data: statsData } = useQuery<GetPermitStatsData>(GET_PERMIT_STATS);

  const accountContextBannerVisible = useAccountContextBannerVisible();

  const pendingCount =
    (statsData?.pendingPermits?.aggregate?.count || 0) + (statsData?.awaitingInfoPermits?.aggregate?.count || 0);

  const subNavItems: PermitSubNavigationItem[] = React.useMemo(
    () => [
      { label: "All Permits", path: "/permits/all" },
      { label: "Pending Applications", path: "/permits/pending", badge: pendingCount || undefined },
      { label: "Permit Types", path: "/permits/types" },
      { label: "Vehicle Exemptions", path: "/permits/exemptions" },
    ],
    [pendingCount],
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        flexGrow: 1,
        pt: accountContextBannerVisible ? 3 : 0,
        bgcolor: (theme: Theme) => theme.palette.grey[100],
      }}
    >
      {/* Sub Navigation */}
      <Box sx={{ bgcolor: "background.paper" }}>
        <Container maxWidth="xl">
          <PermitSubNavigation items={subNavItems} />
        </Container>
      </Box>
      <Container
        sx={{ display: "flex", flexDirection: "column", py: { xs: 1, sm: 3 }, height: "100%", flexGrow: 1 }}
        maxWidth="xl"
      >
        <Outlet />
      </Container>
    </Box>
  );
};

export default PermitsLayout;
